import { useState } from 'react'
import { IconPlayDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import { VideoModal } from 'pages/certificates/components'
import { TrackClick } from 'pages/certificates/tracking'

type CohortTrailerButtonProps = {
  mediaUuid: string
  contentId: string
  contentTitle: string
}

export const CohortTrailerButton = ({
  mediaUuid,
  contentId,
  contentTitle,
}: CohortTrailerButtonProps) => {
  const { t } = useTranslation('@mc/certificates')
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TrackClick
        event='certificateLandingClick'
        action={t('marketingPages.common.playTrailer')}
      >
        <button
          type='button'
          aria-haspopup='dialog'
          className='c-body-small flex cursor-pointer items-center gap-2 rounded-full bg-c-base-1400/50 pr-3 text-c-text-light backdrop-blur focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c-brand-highlight lg:p-1 lg:pr-4'
          onClick={() => setIsOpen(true)}
        >
          <span className='flex size-8 items-center justify-center rounded-full bg-c-base-100 text-c-text-dark md:size-7 lg:size-6'>
            <IconPlayDefault size='sm' />
          </span>
          {t('marketingPages.common.playTrailer')}
        </button>
      </TrackClick>
      <VideoModal
        show={isOpen}
        onCloseModal={() => setIsOpen(false)}
        mediaUuid={mediaUuid}
        contentId={contentId}
        contentTitle={contentTitle}
        contentType={TRACK_CONTENT_TYPES.CERTIFICATE_TRAILER}
      />
    </>
  )
}
